import { Shark } from "shark-mvc";
import ContentPackPage from "./ContentPackPage";
import NousCoreModel from "./NousCoreModel";

class ContentPack extends NousCoreModel {
	content = {};
	description = "";
	relatedContents = [];
	shortCode = "";
	tags = [];
	title = "";
	
	constructor (data) {
		super();

		if (data) {
			this.import(data);
		}
	}

	export () {
		const epxortData = super.export();

		epxortData.content = this.exportObjectField("content");
		epxortData.relatedContents = this.exportObjectField("relatedContents");
		epxortData.tags = this.exportObjectField("tags");

		return epxortData;
	}

	import (data, options) {
		super.import(data, options);

		if (this.content.mainPage) {
			this.content.mainPage = new ContentPackPage(this.content.mainPage);
		}
		if (this.content.secondaryPages) {
			this.content.secondaryPages = this.content.secondaryPages.map(item => new ContentPackPage(item));
		}
	}
}

Shark.registerModel("ContentPack", ContentPack);

export default ContentPack;